var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthicsSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ethics 1",
    clipPath: "url(#clip0_1279_34305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 19.5C9 25.2866 13.7134 30 19.5 30C25.2866 30 30 25.2866 30 19.5C30 13.7134 25.2866 9 19.5 9C13.7134 9 9 13.7134 9 19.5ZM24.9833 17.9833L18.3333 24.6567L14.0167 20.3167L15.65 18.6834L18.3333 21.3433L23.3501 16.35L24.9833 17.9833Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 40C30.9922 40 40 30.9922 40 20H35.3125C35.3125 28.3907 28.3907 35.2344 20 35.2344C11.6093 35.2344 4.76562 28.3907 4.76562 20C4.76562 11.6093 11.6093 4.76562 20 4.76562C23.422 4.76562 26.5859 5.89055 29.1172 7.8125L27.3359 9.59375L35.6093 11.2344L33.9688 2.96086L32.4688 4.46086C29.0469 1.71875 24.7109 0 20 0C9.00781 0 0 9.00781 0 20C0 30.9922 9.00781 40 20 40Z",
    fill: "#34A853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_34305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthicsSvg);
export default __webpack_public_path__ + "static/media/EthicsSvg.f66a1ff55d69d96feb74a146e05889d3.svg";
export { ForwardRef as ReactComponent };